module.exports = __webpack_public_path__ + "img/mqttDTU4.168372eb.jpg";